/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 1ae6e2d8 (Tue May  5 20:16:57 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
  BulkReassignEventsRequestBody,
  BulkReassignEventsRequestBodyToJSON,
  Event,
  EventCategory,
  EventFromJSON,
  Events,
  Events1,
  Events1FromJSON,
  EventsFromJSON,
  EventToJSON,
  FetchEventCategoriesResponse,
  FetchEventCategoriesResponseFromJSON,
  FetchEventOptionsResponse,
  FetchEventOptionsResponseFromJSON,
  FetchLeadershipTrainingEventsResponse,
  FetchLeadershipTrainingEventsResponseFromJSON,
  PublicEvent,
  PublicEventFromJSON,
  PublicEventType,
  Registrant,
  Registrants,
  RegistrantsFromJSON,
  RegistrantToJSON,
  SearchPossibleEventOwnersResponse,
  SearchPossibleEventOwnersResponseFromJSON,
  SearchPublicEventsReply,
  SearchPublicEventsReplyFromJSON,
} from '../models'
import * as runtime from '../runtime'

export interface BulkReassignEventsRequest
  extends runtime.BaseRequestParameters {
  body: BulkReassignEventsRequestBody
}

export interface CreateEventRequest extends runtime.BaseRequestParameters {
  body: Event
}

export interface CreateLeadershipTrainingRegistrantRequest
  extends runtime.BaseRequestParameters {
  eventKey: number
}

export interface CreateRegistrantRequest extends runtime.BaseRequestParameters {
  body: Registrant
}

export interface DeleteEventRequest extends runtime.BaseRequestParameters {
  eventKey: number
}

export interface FetchEventRequest extends runtime.BaseRequestParameters {
  eventKey: number
}

export interface FetchEventCategoriesRequest
  extends runtime.BaseRequestParameters {}

export interface FetchEventOptionsRequest
  extends runtime.BaseRequestParameters {
  includeRoles?: boolean
}

export interface FetchEventRegistrantsRequest
  extends runtime.BaseRequestParameters {
  eventKey: number
  page?: number
  pageSize?: number
  orderBy?: Array<string>
}

export interface FetchEventsRequest extends runtime.BaseRequestParameters {
  page?: number
  pageSize?: number
  orderBy?: Array<string>
  eventType?: string
  search?: string
  eventCreator?: string
  fromDate?: string
  toDate?: string
}

export interface FetchInternationalEventsRequest
  extends runtime.BaseRequestParameters {
  isGlobalEvent: boolean
  fromDate: string
  toDate: string
  eventType?: string
  countryCode?: string
  category?: EventCategory
}

export interface FetchLeadershipTrainingRequest
  extends runtime.BaseRequestParameters {
  page?: number
  pageSize?: number
  orderBy?: Array<string>
  eventType?: string
  search?: string
  eventCreator?: string
  fromDate?: string
  toDate?: string
}

export interface FetchPublicEventDetailsRequest
  extends runtime.BaseRequestParameters {
  publicEventId: string
}

export interface SearchPossibleEventOwnersRequest
  extends runtime.BaseRequestParameters {
  page?: number
  pageSize?: number
  orderBy?: Array<string>
  search?: string
  eventTypes?: Array<PublicEventType>
}

export interface SearchPublicEventsRequest
  extends runtime.BaseRequestParameters {
  postalCode?: string
  usCitiesKey?: number
  milesRadius?: number
  fromDate?: Date
  showOnlineEvents?: boolean
  eventType?: SearchPublicEventsEventTypeEnum
  eventCategory?: string
}

export interface UpdateEventRequest extends runtime.BaseRequestParameters {
  body: Event
}

/**
 * EventsApi - interface
 *
 * @export
 * @interface EventsApiInterface
 */
export interface EventsApiInterface {
  /**
   *
   * @summary Reassign the owners of all the events in the request.
   * @param {BulkReassignEventsRequestBody} bulkReassignEventsRequestBody
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventsApiInterface
   */
  bulkReassignEventsRaw(
    requestParameters: BulkReassignEventsRequest
  ): Promise<runtime.ApiResponse<void>>

  /**
   * Reassign the owners of all the events in the request.
   */
  bulkReassignEvents(
    requestParameters: BulkReassignEventsRequest
  ): Promise<void>

  /**
   *
   * @summary Create a new Event.
   * @param {Event} event
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventsApiInterface
   */
  createEventRaw(
    requestParameters: CreateEventRequest
  ): Promise<runtime.ApiResponse<Event>>

  /**
   * Create a new Event.
   */
  createEvent(requestParameters: CreateEventRequest): Promise<Event>

  /**
   * Creates a new registrant. This endpoint registers the logged-in user (the requester) for an internal event within the \'Leadership Training\' category. It requires the event ID and uses the connected user\'s session information to auto-populate the registration details
   * @summary Create a new Leadership Training registrant
   * @param {number} eventKey Unique identifier for the event.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventsApiInterface
   */
  createLeadershipTrainingRegistrantRaw(
    requestParameters: CreateLeadershipTrainingRegistrantRequest
  ): Promise<runtime.ApiResponse<void>>

  /**
   * Creates a new registrant. This endpoint registers the logged-in user (the requester) for an internal event within the \'Leadership Training\' category. It requires the event ID and uses the connected user\'s session information to auto-populate the registration details
   * Create a new Leadership Training registrant
   */
  createLeadershipTrainingRegistrant(
    requestParameters: CreateLeadershipTrainingRegistrantRequest
  ): Promise<void>

  /**
   * A registrant can sign up for an event with basic contact information.
   * @summary Add a new registrant to an event.
   * @param {Registrant} registrant
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventsApiInterface
   */
  createRegistrantRaw(
    requestParameters: CreateRegistrantRequest
  ): Promise<runtime.ApiResponse<void>>

  /**
   * A registrant can sign up for an event with basic contact information.
   * Add a new registrant to an event.
   */
  createRegistrant(requestParameters: CreateRegistrantRequest): Promise<void>

  /**
   *
   * @summary Delete an event.
   * @param {number} eventKey The &#x60;eventKey&#x60; is the unique identifier for an Event.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventsApiInterface
   */
  deleteEventRaw(
    requestParameters: DeleteEventRequest
  ): Promise<runtime.ApiResponse<void>>

  /**
   * Delete an event.
   */
  deleteEvent(requestParameters: DeleteEventRequest): Promise<void>

  /**
   * Provide event details given an event identifier.    ## PERMISSIONS:   - The requester must have an active Event/viewDetail permission, else a 403 status code will be returned.   - A Event/viewDetail[their team\'s] permission allows the requester to fetch event within their downline.   - A Event/viewDetail[any] permission allows the requester to fetch an event that anyone owns in the system.
   * @summary Fetch an existing event given an identifier.
   * @param {number} eventKey The &#x60;eventKey&#x60; is the unique identifier for an Event.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventsApiInterface
   */
  fetchEventRaw(
    requestParameters: FetchEventRequest
  ): Promise<runtime.ApiResponse<Event>>

  /**
   * Provide event details given an event identifier.    ## PERMISSIONS:   - The requester must have an active Event/viewDetail permission, else a 403 status code will be returned.   - A Event/viewDetail[their team\'s] permission allows the requester to fetch event within their downline.   - A Event/viewDetail[any] permission allows the requester to fetch an event that anyone owns in the system.
   * Fetch an existing event given an identifier.
   */
  fetchEvent(requestParameters: FetchEventRequest): Promise<Event>

  /**
   * Returns all event categories. This is a public endpoint used to populate dropdowns or selection menus where event categories are required.
   * @summary Fetch all event categories.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventsApiInterface
   */
  fetchEventCategoriesRaw(
    requestParameters: FetchEventCategoriesRequest
  ): Promise<runtime.ApiResponse<FetchEventCategoriesResponse>>

  /**
   * Returns all event categories. This is a public endpoint used to populate dropdowns or selection menus where event categories are required.
   * Fetch all event categories.
   */
  fetchEventCategories(): Promise<FetchEventCategoriesResponse>

  /**
   * Retrieves all available event types. Optionally, leadership training roles can be included by setting the includeRoles query parameter to true. This endpoint is commonly used to populate dropdowns or selection menus where event types are required.
   * @summary Returns all event types and leadership training roles
   * @param {boolean} [includeRoles] If true, include leadership training roles in the response. Defaults to false.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventsApiInterface
   */
  fetchEventOptionsRaw(
    requestParameters: FetchEventOptionsRequest
  ): Promise<runtime.ApiResponse<FetchEventOptionsResponse>>

  /**
   * Retrieves all available event types. Optionally, leadership training roles can be included by setting the includeRoles query parameter to true. This endpoint is commonly used to populate dropdowns or selection menus where event types are required.
   * Returns all event types and leadership training roles
   */
  fetchEventOptions(
    requestParameters: FetchEventOptionsRequest
  ): Promise<FetchEventOptionsResponse>

  /**
   *
   * @summary List of registrants for a given event.
   * @param {number} eventKey Unique identifier for the event.
   * @param {number} [page] The current page of data to be returned. Must be at least 1.
   * @param {number} [pageSize] The length of data to be returned on the requested page. Must be at least 1
   * @param {Array<string>} [orderBy] The order by properties and direction for the data in the endpoint. See endpoint description for what is applicable. Must be in a format like: \&#39;property ASC\&#39;
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventsApiInterface
   */
  fetchEventRegistrantsRaw(
    requestParameters: FetchEventRegistrantsRequest
  ): Promise<runtime.ApiResponse<Registrants>>

  /**
   * List of registrants for a given event.
   */
  fetchEventRegistrants(
    requestParameters: FetchEventRegistrantsRequest
  ): Promise<Registrants>

  /**
   * The list of events within a given date range. If a date range is not supplied then it defaults to dates between today and a year from today.    ## FILTERING: - search: search text must be at least 3 characters in length. Including this query parameter will match your search text to an event\'s name, postal code or creator. - eventType: will return events within the specific type - eventCreator: will return events for the specific creator   ## PAGINATION: - If pagination query parameters are included, the request will be paginated and ordered by the specified page, pageSize, and orderBy. - orderBy: valid order by properties include: name, startDate, startTime, CreatedBy, city, eventTypeKey. Supplying anything else will result in an error. - The requested pagination will be returned in the response, including the total count of all data, which will allow the requester to calculate the total amount of pages available with the current pageSize.       ## PERMISSIONS: - The requester must have an active Event/viewDetail permission, else a 403 status code will be returned. - A Event/viewDetail[their team\'s] permission allows the requester to fetch event within their downline. - A Event/viewDetail[any] permission allows the requester to fetch an event that anyone owns in the system.
   * @summary List of events within a given date range.
   * @param {number} [page] The current page of data to be returned. Must be at least 1.
   * @param {number} [pageSize] The length of data to be returned on the requested page. Must be at least 1
   * @param {Array<string>} [orderBy] The order by properties and direction for the data in the endpoint. See endpoint description for what is applicable. Must be in a format like: \&#39;property ASC\&#39;
   * @param {string} [eventType] Supply an event type to filter events to a specific type.
   * @param {string} [search] Search for Events by name or Postal Code. Must be at least 3 characters in length.
   * @param {string} [eventCreator] Supply an event creator to filter events to a specific creator.
   * @param {string} [fromDate] The beginning of the date range search query, performed against the startDate of an event. When not provided, it defaults to today\&#39;s date.
   * @param {string} [toDate] The ending of the date range search query, performed against the startDate of an event. When not provided it defaults to a year from the fromDate.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventsApiInterface
   */
  fetchEventsRaw(
    requestParameters: FetchEventsRequest
  ): Promise<runtime.ApiResponse<Events1>>

  /**
   * The list of events within a given date range. If a date range is not supplied then it defaults to dates between today and a year from today.    ## FILTERING: - search: search text must be at least 3 characters in length. Including this query parameter will match your search text to an event\'s name, postal code or creator. - eventType: will return events within the specific type - eventCreator: will return events for the specific creator   ## PAGINATION: - If pagination query parameters are included, the request will be paginated and ordered by the specified page, pageSize, and orderBy. - orderBy: valid order by properties include: name, startDate, startTime, CreatedBy, city, eventTypeKey. Supplying anything else will result in an error. - The requested pagination will be returned in the response, including the total count of all data, which will allow the requester to calculate the total amount of pages available with the current pageSize.       ## PERMISSIONS: - The requester must have an active Event/viewDetail permission, else a 403 status code will be returned. - A Event/viewDetail[their team\'s] permission allows the requester to fetch event within their downline. - A Event/viewDetail[any] permission allows the requester to fetch an event that anyone owns in the system.
   * List of events within a given date range.
   */
  fetchEvents(requestParameters: FetchEventsRequest): Promise<Events1>

  /**
   * The list of events within a given date range (startDate BETWEEN from AND to). If no results between date ranges the endpoint will return the FIRST event with start_date >= To for the specific country provided by user,   the isFirstEventCloserToEndDate flag will be set to true so the developer may change the specific response to show in the FE.    ## FILTERING:   - eventType: will return events within the specific type   - eventLocationType: will return events within the specific location type 0=local, 1=global   - eventCountry: will return events within specific country    ## RESPONSE:   - isFirstEventCloserToEndDate: It will be only true if the aren\'t between date ranges and the there is at least ONE event near after such date ranges   - events: It will be either an array of Events or empty event, containing at least one event or empty array if there aren\'t events between date ranges nor near such ranges
   * @summary List of events within a given date range, country, eventType and eventLocationType.
   * @param {boolean} isGlobalEvent Specify wether an event is online or not. A false value means the event will be local otherwise global.
   * @param {string} fromDate The beginning of the date range search query, performed against the startDate of an event. This params is required.
   * @param {string} toDate The ending of the date range search query, performed against the startDate of an event. This params is required.
   * @param {string} [eventType] The type of event:  Information Meeting, Open House, Practicum.
   * @param {string} [countryCode] Country Code where the event will take place. This params is required if isGlobalEvent is set to false.
   * @param {EventCategory} [category]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventsApiInterface
   */
  fetchInternationalEventsRaw(
    requestParameters: FetchInternationalEventsRequest
  ): Promise<runtime.ApiResponse<Events>>

  /**
   * The list of events within a given date range (startDate BETWEEN from AND to). If no results between date ranges the endpoint will return the FIRST event with start_date >= To for the specific country provided by user,   the isFirstEventCloserToEndDate flag will be set to true so the developer may change the specific response to show in the FE.    ## FILTERING:   - eventType: will return events within the specific type   - eventLocationType: will return events within the specific location type 0=local, 1=global   - eventCountry: will return events within specific country    ## RESPONSE:   - isFirstEventCloserToEndDate: It will be only true if the aren\'t between date ranges and the there is at least ONE event near after such date ranges   - events: It will be either an array of Events or empty event, containing at least one event or empty array if there aren\'t events between date ranges nor near such ranges
   * List of events within a given date range, country, eventType and eventLocationType.
   */
  fetchInternationalEvents(
    requestParameters: FetchInternationalEventsRequest
  ): Promise<Events>

  /**
   * Provides a list of internal events for the requester:    ## FILTERING:  - search: search text must be at least 3 characters in length. Including this query parameter will match your search text to an event\'s name, postal code or creator. - eventType: will return events within the specific type - eventCreator: will return events for the specific creator   ## PAGINATION:  - If pagination query parameters are included, the request will be paginated and ordered by the specified page, pageSize, and orderBy. - orderBy: valid order by properties include: name, startDate, startTime, CreatedBy, city, eventTypeKey. Supplying anything else will result in an error. - The requested pagination will be returned in the response, including the total count of all entries, which will allow the requester to calculate the total number of pages available with the current pageSize.      ## PERMISSIONS:  - The requester must have an active Event/viewDetail permission, else a 403 status code will be returned. - A Event/viewDetail[their team\'s] permission allows the requester to fetch event within their downline. - A Event/viewDetail[any] permission allows the requester to fetch an event that anyone owns in the system.
   * @summary Fetch existing internal events for the requester denoting if the requester is registered for any given event.
   * @param {number} [page] The current page of data to be returned. Must be at least 1.
   * @param {number} [pageSize] The length of data to be returned on the requested page. Must be at least 1
   * @param {Array<string>} [orderBy] The order by properties and direction for the data in the endpoint. See endpoint description for what is applicable. Must be in a format like: \&#39;property ASC\&#39;
   * @param {string} [eventType] Supply an event type to filter events to a specific type.
   * @param {string} [search] Search for Events by name or Postal Code. Must be at least 3 characters in length.
   * @param {string} [eventCreator] Supply an event creator to filter events to a specific creator.
   * @param {string} [fromDate] The beginning of the date range search query, performed against the startDate of an event. When not provided, it defaults to today\&#39;s date.
   * @param {string} [toDate] The ending of the date range search query, performed against the startDate of an event. When not provided it defaults to a year from the fromDate.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventsApiInterface
   */
  fetchLeadershipTrainingRaw(
    requestParameters: FetchLeadershipTrainingRequest
  ): Promise<runtime.ApiResponse<FetchLeadershipTrainingEventsResponse>>

  /**
   * Provides a list of internal events for the requester:    ## FILTERING:  - search: search text must be at least 3 characters in length. Including this query parameter will match your search text to an event\'s name, postal code or creator. - eventType: will return events within the specific type - eventCreator: will return events for the specific creator   ## PAGINATION:  - If pagination query parameters are included, the request will be paginated and ordered by the specified page, pageSize, and orderBy. - orderBy: valid order by properties include: name, startDate, startTime, CreatedBy, city, eventTypeKey. Supplying anything else will result in an error. - The requested pagination will be returned in the response, including the total count of all entries, which will allow the requester to calculate the total number of pages available with the current pageSize.      ## PERMISSIONS:  - The requester must have an active Event/viewDetail permission, else a 403 status code will be returned. - A Event/viewDetail[their team\'s] permission allows the requester to fetch event within their downline. - A Event/viewDetail[any] permission allows the requester to fetch an event that anyone owns in the system.
   * Fetch existing internal events for the requester denoting if the requester is registered for any given event.
   */
  fetchLeadershipTraining(
    requestParameters: FetchLeadershipTrainingRequest
  ): Promise<FetchLeadershipTrainingEventsResponse>

  /**
   * Provide event details given an event identifier.
   * @summary Fetch an existing event given an identifier.
   * @param {string} publicEventId Use the publicEvent.id from the Public Search Events API to fetch details of an event.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventsApiInterface
   */
  fetchPublicEventDetailsRaw(
    requestParameters: FetchPublicEventDetailsRequest
  ): Promise<runtime.ApiResponse<PublicEvent>>

  /**
   * Provide event details given an event identifier.
   * Fetch an existing event given an identifier.
   */
  fetchPublicEventDetails(
    requestParameters: FetchPublicEventDetailsRequest
  ): Promise<PublicEvent>

  /**
   *  ## PERMISSIONS: - Requester must possess a User/view grant, otherwise a 403 will be returned. - User/view[their team\'s] grant allows the requester to view users only in the requester\'s downline. - User/view[any] grant allows the user to see all users that are able to manage the event types passed.  ## FILTERING: - search: search text must be at least 3 characters in length. Including this query parameter will match your search text to a user\'s firstName, lastName, username, email, and name of the role they actively have. - eventTypes: the types of events the caller is trying to find a possible owner for. This limits the actors returned to only those who have the Event/manage{type} grant where {type} is the types of events.  ## PAGINATION: - If pagination query parameters are not provided, pagination will not be included in the request. WARNING: this could cause a very large query and is not recommended unless the result set is known to be limited. - If pagination query parameters are included, the request will be paginated to the specified page and pageSize. - The requested pagination will be returned in the response, including the total count of all data, which will allow the requester to calculate the total amount of pages available with the current pageSize.
   * @summary An endpoint to be able to search for possible event owners - active actors who are able to manage certain types of event. Takes into account the types of events that are being reassigned and verifies that the actor records can manage those events.
   * @param {number} [page] The current page of data to be returned. Must be at least 1.
   * @param {number} [pageSize] The length of data to be returned on the requested page. Must be at least 1
   * @param {Array<string>} [orderBy] The order by properties and direction for the data in the endpoint. See endpoint description for what is applicable. Must be in a format like: \&#39;property ASC\&#39;
   * @param {string} [search] Search for possible event owners by firstName or lastName.
   * @param {Array<PublicEventType>} [eventTypes]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventsApiInterface
   */
  searchPossibleEventOwnersRaw(
    requestParameters: SearchPossibleEventOwnersRequest
  ): Promise<runtime.ApiResponse<SearchPossibleEventOwnersResponse>>

  /**
   *  ## PERMISSIONS: - Requester must possess a User/view grant, otherwise a 403 will be returned. - User/view[their team\'s] grant allows the requester to view users only in the requester\'s downline. - User/view[any] grant allows the user to see all users that are able to manage the event types passed.  ## FILTERING: - search: search text must be at least 3 characters in length. Including this query parameter will match your search text to a user\'s firstName, lastName, username, email, and name of the role they actively have. - eventTypes: the types of events the caller is trying to find a possible owner for. This limits the actors returned to only those who have the Event/manage{type} grant where {type} is the types of events.  ## PAGINATION: - If pagination query parameters are not provided, pagination will not be included in the request. WARNING: this could cause a very large query and is not recommended unless the result set is known to be limited. - If pagination query parameters are included, the request will be paginated to the specified page and pageSize. - The requested pagination will be returned in the response, including the total count of all data, which will allow the requester to calculate the total amount of pages available with the current pageSize.
   * An endpoint to be able to search for possible event owners - active actors who are able to manage certain types of event. Takes into account the types of events that are being reassigned and verifies that the actor records can manage those events.
   */
  searchPossibleEventOwners(
    requestParameters: SearchPossibleEventOwnersRequest
  ): Promise<SearchPossibleEventOwnersResponse>

  /**
   * Returns some events within a radius of either a postal code (preferred) or a city and state. If an event type is provided then only those events will be included. In addition, if an online or offline event is required results can be limited only to those events, by default both online and offline are displayed.
   * @summary Find nearby events so that users can register to an event. The search can further be filtered by type of event or whether it is online or offline, when left blank all events are displayed.
   * @param {string} [postalCode] The postal code to search. Preferred to city+state if supplied.
   * @param {number} [usCitiesKey] The usCitiesKey to search within. Ignored if postal code is supplied.
   * @param {number} [milesRadius] The radius to search within, specified in miles. Extreme values will be capped at a maximum. If omitted, some default behavior will be used.
   * @param {Date} [fromDate] The beginning of the date range search query. When not provided, it defaults to today\&#39;s date.
   * @param {boolean} [showOnlineEvents] List only the online events. When performing a proximity search, online events are not displayed.
   * @param {'Information Meeting' | 'Open House' | 'Practicum' | 'Parent Practicum' | 'Classical Conversations Overview' | 'Windows Into Program' | 'Excellence in Education Event' | 'Parent Equipping' | 'Experience Curriculum' | 'Curriculum At Home' | 'Book Club' | 'Sales Orientation' | 'Retreats' | 'LCD Orientation' | 'Other - Discover' | 'Other - Experience' | 'Other - Prepare' | 'Other - Leadership Training'} [eventType]
   * @param {string} [eventCategory] Filter events by category (e.g., Discover, Experience, Prepare, Leadership Training)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventsApiInterface
   */
  searchPublicEventsRaw(
    requestParameters: SearchPublicEventsRequest
  ): Promise<runtime.ApiResponse<SearchPublicEventsReply>>

  /**
   * Returns some events within a radius of either a postal code (preferred) or a city and state. If an event type is provided then only those events will be included. In addition, if an online or offline event is required results can be limited only to those events, by default both online and offline are displayed.
   * Find nearby events so that users can register to an event. The search can further be filtered by type of event or whether it is online or offline, when left blank all events are displayed.
   */
  searchPublicEvents(
    requestParameters: SearchPublicEventsRequest
  ): Promise<SearchPublicEventsReply>

  /**
   *
   * @summary Update an existing Event.
   * @param {Event} event
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventsApiInterface
   */
  updateEventRaw(
    requestParameters: UpdateEventRequest
  ): Promise<runtime.ApiResponse<void>>

  /**
   * Update an existing Event.
   */
  updateEvent(requestParameters: UpdateEventRequest): Promise<void>
}

/**
 *
 */
export class EventsApi extends runtime.BaseAPI implements EventsApiInterface {
  /**
   * Reassign the owners of all the events in the request.
   */
  async bulkReassignEventsRaw(
    requestParameters: BulkReassignEventsRequest
  ): Promise<runtime.ApiResponse<void>> {
    if (
      requestParameters.body === null ||
      requestParameters.body === undefined
    ) {
      throw new runtime.RequiredError(
        'body',
        'Required parameter requestParameters.body was null or undefined when calling bulkReassignEvents.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/bulkReassignEvents`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
      body: BulkReassignEventsRequestBodyToJSON(requestParameters.body),
      $signal: requestParameters.$signal,
    })

    return new runtime.VoidApiResponse(response)
  }

  /**
   * Reassign the owners of all the events in the request.
   */
  async bulkReassignEvents(
    requestParameters: BulkReassignEventsRequest
  ): Promise<void> {
    await this.bulkReassignEventsRaw(requestParameters)
  }

  /**
   * Create a new Event.
   */
  async createEventRaw(
    requestParameters: CreateEventRequest
  ): Promise<runtime.ApiResponse<Event>> {
    if (
      requestParameters.body === null ||
      requestParameters.body === undefined
    ) {
      throw new runtime.RequiredError(
        'body',
        'Required parameter requestParameters.body was null or undefined when calling createEvent.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/events`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
      body: EventToJSON(requestParameters.body),
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      EventFromJSON(jsonValue)
    )
  }

  /**
   * Create a new Event.
   */
  async createEvent(requestParameters: CreateEventRequest): Promise<Event> {
    const response = await this.createEventRaw(requestParameters)
    return await response.value()
  }

  /**
   * Creates a new registrant. This endpoint registers the logged-in user (the requester) for an internal event within the \'Leadership Training\' category. It requires the event ID and uses the connected user\'s session information to auto-populate the registration details
   * Create a new Leadership Training registrant
   */
  async createLeadershipTrainingRegistrantRaw(
    requestParameters: CreateLeadershipTrainingRegistrantRequest
  ): Promise<runtime.ApiResponse<void>> {
    if (
      requestParameters.eventKey === null ||
      requestParameters.eventKey === undefined
    ) {
      throw new runtime.RequiredError(
        'eventKey',
        'Required parameter requestParameters.eventKey was null or undefined when calling createLeadershipTrainingRegistrant.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/registrants/leadershipTraining/{eventKey}`.replace(
        `{${'eventKey'}}`,
        encodeURIComponent(String(requestParameters.eventKey))
      ),
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.VoidApiResponse(response)
  }

  /**
   * Creates a new registrant. This endpoint registers the logged-in user (the requester) for an internal event within the \'Leadership Training\' category. It requires the event ID and uses the connected user\'s session information to auto-populate the registration details
   * Create a new Leadership Training registrant
   */
  async createLeadershipTrainingRegistrant(
    requestParameters: CreateLeadershipTrainingRegistrantRequest
  ): Promise<void> {
    await this.createLeadershipTrainingRegistrantRaw(requestParameters)
  }

  /**
   * A registrant can sign up for an event with basic contact information.
   * Add a new registrant to an event.
   */
  async createRegistrantRaw(
    requestParameters: CreateRegistrantRequest
  ): Promise<runtime.ApiResponse<void>> {
    if (
      requestParameters.body === null ||
      requestParameters.body === undefined
    ) {
      throw new runtime.RequiredError(
        'body',
        'Required parameter requestParameters.body was null or undefined when calling createRegistrant.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    const response = await this.request({
      path: `/registrants`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
      body: RegistrantToJSON(requestParameters.body),
      $signal: requestParameters.$signal,
    })

    return new runtime.VoidApiResponse(response)
  }

  /**
   * A registrant can sign up for an event with basic contact information.
   * Add a new registrant to an event.
   */
  async createRegistrant(
    requestParameters: CreateRegistrantRequest
  ): Promise<void> {
    await this.createRegistrantRaw(requestParameters)
  }

  /**
   * Delete an event.
   */
  async deleteEventRaw(
    requestParameters: DeleteEventRequest
  ): Promise<runtime.ApiResponse<void>> {
    if (
      requestParameters.eventKey === null ||
      requestParameters.eventKey === undefined
    ) {
      throw new runtime.RequiredError(
        'eventKey',
        'Required parameter requestParameters.eventKey was null or undefined when calling deleteEvent.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/events/{eventKey}`.replace(
        `{${'eventKey'}}`,
        encodeURIComponent(String(requestParameters.eventKey))
      ),
      method: 'DELETE',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.VoidApiResponse(response)
  }

  /**
   * Delete an event.
   */
  async deleteEvent(requestParameters: DeleteEventRequest): Promise<void> {
    await this.deleteEventRaw(requestParameters)
  }

  /**
   * Provide event details given an event identifier.    ## PERMISSIONS:   - The requester must have an active Event/viewDetail permission, else a 403 status code will be returned.   - A Event/viewDetail[their team\'s] permission allows the requester to fetch event within their downline.   - A Event/viewDetail[any] permission allows the requester to fetch an event that anyone owns in the system.
   * Fetch an existing event given an identifier.
   */
  async fetchEventRaw(
    requestParameters: FetchEventRequest
  ): Promise<runtime.ApiResponse<Event>> {
    if (
      requestParameters.eventKey === null ||
      requestParameters.eventKey === undefined
    ) {
      throw new runtime.RequiredError(
        'eventKey',
        'Required parameter requestParameters.eventKey was null or undefined when calling fetchEvent.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/events/{eventKey}`.replace(
        `{${'eventKey'}}`,
        encodeURIComponent(String(requestParameters.eventKey))
      ),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      EventFromJSON(jsonValue)
    )
  }

  /**
   * Provide event details given an event identifier.    ## PERMISSIONS:   - The requester must have an active Event/viewDetail permission, else a 403 status code will be returned.   - A Event/viewDetail[their team\'s] permission allows the requester to fetch event within their downline.   - A Event/viewDetail[any] permission allows the requester to fetch an event that anyone owns in the system.
   * Fetch an existing event given an identifier.
   */
  async fetchEvent(requestParameters: FetchEventRequest): Promise<Event> {
    const response = await this.fetchEventRaw(requestParameters)
    return await response.value()
  }

  /**
   * Returns all event categories. This is a public endpoint used to populate dropdowns or selection menus where event categories are required.
   * Fetch all event categories.
   */
  async fetchEventCategoriesRaw(
    requestParameters: FetchEventCategoriesRequest
  ): Promise<runtime.ApiResponse<FetchEventCategoriesResponse>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/events/categories`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FetchEventCategoriesResponseFromJSON(jsonValue)
    )
  }

  /**
   * Returns all event categories. This is a public endpoint used to populate dropdowns or selection menus where event categories are required.
   * Fetch all event categories.
   */
  async fetchEventCategories(
    requestParameters?: FetchEventCategoriesRequest
  ): Promise<FetchEventCategoriesResponse> {
    const response = await this.fetchEventCategoriesRaw(requestParameters || {})
    return await response.value()
  }

  /**
   * Retrieves all available event types. Optionally, leadership training roles can be included by setting the includeRoles query parameter to true. This endpoint is commonly used to populate dropdowns or selection menus where event types are required.
   * Returns all event types and leadership training roles
   */
  async fetchEventOptionsRaw(
    requestParameters: FetchEventOptionsRequest
  ): Promise<runtime.ApiResponse<FetchEventOptionsResponse>> {
    const queryParameters: any = {}

    if (requestParameters.includeRoles !== undefined) {
      queryParameters['includeRoles'] = requestParameters.includeRoles
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/events/options`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FetchEventOptionsResponseFromJSON(jsonValue)
    )
  }

  /**
   * Retrieves all available event types. Optionally, leadership training roles can be included by setting the includeRoles query parameter to true. This endpoint is commonly used to populate dropdowns or selection menus where event types are required.
   * Returns all event types and leadership training roles
   */
  async fetchEventOptions(
    requestParameters?: FetchEventOptionsRequest
  ): Promise<FetchEventOptionsResponse> {
    const response = await this.fetchEventOptionsRaw(requestParameters || {})
    return await response.value()
  }

  /**
   * List of registrants for a given event.
   */
  async fetchEventRegistrantsRaw(
    requestParameters: FetchEventRegistrantsRequest
  ): Promise<runtime.ApiResponse<Registrants>> {
    if (
      requestParameters.eventKey === null ||
      requestParameters.eventKey === undefined
    ) {
      throw new runtime.RequiredError(
        'eventKey',
        'Required parameter requestParameters.eventKey was null or undefined when calling fetchEventRegistrants.'
      )
    }

    const queryParameters: any = {}

    if (requestParameters.page !== undefined) {
      queryParameters['page'] = requestParameters.page
    }

    if (requestParameters.pageSize !== undefined) {
      queryParameters['pageSize'] = requestParameters.pageSize
    }

    if (requestParameters.orderBy) {
      queryParameters['orderBy'] = requestParameters.orderBy
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/events/{eventKey}/registrants`.replace(
        `{${'eventKey'}}`,
        encodeURIComponent(String(requestParameters.eventKey))
      ),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RegistrantsFromJSON(jsonValue)
    )
  }

  /**
   * List of registrants for a given event.
   */
  async fetchEventRegistrants(
    requestParameters: FetchEventRegistrantsRequest
  ): Promise<Registrants> {
    const response = await this.fetchEventRegistrantsRaw(requestParameters)
    return await response.value()
  }

  /**
   * The list of events within a given date range. If a date range is not supplied then it defaults to dates between today and a year from today.    ## FILTERING: - search: search text must be at least 3 characters in length. Including this query parameter will match your search text to an event\'s name, postal code or creator. - eventType: will return events within the specific type - eventCreator: will return events for the specific creator   ## PAGINATION: - If pagination query parameters are included, the request will be paginated and ordered by the specified page, pageSize, and orderBy. - orderBy: valid order by properties include: name, startDate, startTime, CreatedBy, city, eventTypeKey. Supplying anything else will result in an error. - The requested pagination will be returned in the response, including the total count of all data, which will allow the requester to calculate the total amount of pages available with the current pageSize.       ## PERMISSIONS: - The requester must have an active Event/viewDetail permission, else a 403 status code will be returned. - A Event/viewDetail[their team\'s] permission allows the requester to fetch event within their downline. - A Event/viewDetail[any] permission allows the requester to fetch an event that anyone owns in the system.
   * List of events within a given date range.
   */
  async fetchEventsRaw(
    requestParameters: FetchEventsRequest
  ): Promise<runtime.ApiResponse<Events1>> {
    const queryParameters: any = {}

    if (requestParameters.page !== undefined) {
      queryParameters['page'] = requestParameters.page
    }

    if (requestParameters.pageSize !== undefined) {
      queryParameters['pageSize'] = requestParameters.pageSize
    }

    if (requestParameters.orderBy) {
      queryParameters['orderBy'] = requestParameters.orderBy
    }

    if (requestParameters.eventType !== undefined) {
      queryParameters['eventType'] = requestParameters.eventType
    }

    if (requestParameters.search !== undefined) {
      queryParameters['search'] = requestParameters.search
    }

    if (requestParameters.eventCreator !== undefined) {
      queryParameters['eventCreator'] = requestParameters.eventCreator
    }

    if (requestParameters.fromDate !== undefined) {
      queryParameters['fromDate'] = requestParameters.fromDate
    }

    if (requestParameters.toDate !== undefined) {
      queryParameters['toDate'] = requestParameters.toDate
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/events`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      Events1FromJSON(jsonValue)
    )
  }

  /**
   * The list of events within a given date range. If a date range is not supplied then it defaults to dates between today and a year from today.    ## FILTERING: - search: search text must be at least 3 characters in length. Including this query parameter will match your search text to an event\'s name, postal code or creator. - eventType: will return events within the specific type - eventCreator: will return events for the specific creator   ## PAGINATION: - If pagination query parameters are included, the request will be paginated and ordered by the specified page, pageSize, and orderBy. - orderBy: valid order by properties include: name, startDate, startTime, CreatedBy, city, eventTypeKey. Supplying anything else will result in an error. - The requested pagination will be returned in the response, including the total count of all data, which will allow the requester to calculate the total amount of pages available with the current pageSize.       ## PERMISSIONS: - The requester must have an active Event/viewDetail permission, else a 403 status code will be returned. - A Event/viewDetail[their team\'s] permission allows the requester to fetch event within their downline. - A Event/viewDetail[any] permission allows the requester to fetch an event that anyone owns in the system.
   * List of events within a given date range.
   */
  async fetchEvents(requestParameters?: FetchEventsRequest): Promise<Events1> {
    const response = await this.fetchEventsRaw(requestParameters || {})
    return await response.value()
  }

  /**
   * The list of events within a given date range (startDate BETWEEN from AND to). If no results between date ranges the endpoint will return the FIRST event with start_date >= To for the specific country provided by user,   the isFirstEventCloserToEndDate flag will be set to true so the developer may change the specific response to show in the FE.    ## FILTERING:   - eventType: will return events within the specific type   - eventLocationType: will return events within the specific location type 0=local, 1=global   - eventCountry: will return events within specific country    ## RESPONSE:   - isFirstEventCloserToEndDate: It will be only true if the aren\'t between date ranges and the there is at least ONE event near after such date ranges   - events: It will be either an array of Events or empty event, containing at least one event or empty array if there aren\'t events between date ranges nor near such ranges
   * List of events within a given date range, country, eventType and eventLocationType.
   */
  async fetchInternationalEventsRaw(
    requestParameters: FetchInternationalEventsRequest
  ): Promise<runtime.ApiResponse<Events>> {
    if (
      requestParameters.isGlobalEvent === null ||
      requestParameters.isGlobalEvent === undefined
    ) {
      throw new runtime.RequiredError(
        'isGlobalEvent',
        'Required parameter requestParameters.isGlobalEvent was null or undefined when calling fetchInternationalEvents.'
      )
    }

    if (
      requestParameters.fromDate === null ||
      requestParameters.fromDate === undefined
    ) {
      throw new runtime.RequiredError(
        'fromDate',
        'Required parameter requestParameters.fromDate was null or undefined when calling fetchInternationalEvents.'
      )
    }

    if (
      requestParameters.toDate === null ||
      requestParameters.toDate === undefined
    ) {
      throw new runtime.RequiredError(
        'toDate',
        'Required parameter requestParameters.toDate was null or undefined when calling fetchInternationalEvents.'
      )
    }

    const queryParameters: any = {}

    if (requestParameters.eventType !== undefined) {
      queryParameters['eventType'] = requestParameters.eventType
    }

    if (requestParameters.isGlobalEvent !== undefined) {
      queryParameters['isGlobalEvent'] = requestParameters.isGlobalEvent
    }

    if (requestParameters.countryCode !== undefined) {
      queryParameters['countryCode'] = requestParameters.countryCode
    }

    if (requestParameters.fromDate !== undefined) {
      queryParameters['fromDate'] = requestParameters.fromDate
    }

    if (requestParameters.toDate !== undefined) {
      queryParameters['toDate'] = requestParameters.toDate
    }

    if (requestParameters.category !== undefined) {
      queryParameters['category'] = requestParameters.category
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/events/international/search`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      EventsFromJSON(jsonValue)
    )
  }

  /**
   * The list of events within a given date range (startDate BETWEEN from AND to). If no results between date ranges the endpoint will return the FIRST event with start_date >= To for the specific country provided by user,   the isFirstEventCloserToEndDate flag will be set to true so the developer may change the specific response to show in the FE.    ## FILTERING:   - eventType: will return events within the specific type   - eventLocationType: will return events within the specific location type 0=local, 1=global   - eventCountry: will return events within specific country    ## RESPONSE:   - isFirstEventCloserToEndDate: It will be only true if the aren\'t between date ranges and the there is at least ONE event near after such date ranges   - events: It will be either an array of Events or empty event, containing at least one event or empty array if there aren\'t events between date ranges nor near such ranges
   * List of events within a given date range, country, eventType and eventLocationType.
   */
  async fetchInternationalEvents(
    requestParameters: FetchInternationalEventsRequest
  ): Promise<Events> {
    const response = await this.fetchInternationalEventsRaw(requestParameters)
    return await response.value()
  }

  /**
   * Provides a list of internal events for the requester:    ## FILTERING:  - search: search text must be at least 3 characters in length. Including this query parameter will match your search text to an event\'s name, postal code or creator. - eventType: will return events within the specific type - eventCreator: will return events for the specific creator   ## PAGINATION:  - If pagination query parameters are included, the request will be paginated and ordered by the specified page, pageSize, and orderBy. - orderBy: valid order by properties include: name, startDate, startTime, CreatedBy, city, eventTypeKey. Supplying anything else will result in an error. - The requested pagination will be returned in the response, including the total count of all entries, which will allow the requester to calculate the total number of pages available with the current pageSize.      ## PERMISSIONS:  - The requester must have an active Event/viewDetail permission, else a 403 status code will be returned. - A Event/viewDetail[their team\'s] permission allows the requester to fetch event within their downline. - A Event/viewDetail[any] permission allows the requester to fetch an event that anyone owns in the system.
   * Fetch existing internal events for the requester denoting if the requester is registered for any given event.
   */
  async fetchLeadershipTrainingRaw(
    requestParameters: FetchLeadershipTrainingRequest
  ): Promise<runtime.ApiResponse<FetchLeadershipTrainingEventsResponse>> {
    const queryParameters: any = {}

    if (requestParameters.page !== undefined) {
      queryParameters['page'] = requestParameters.page
    }

    if (requestParameters.pageSize !== undefined) {
      queryParameters['pageSize'] = requestParameters.pageSize
    }

    if (requestParameters.orderBy) {
      queryParameters['orderBy'] = requestParameters.orderBy
    }

    if (requestParameters.eventType !== undefined) {
      queryParameters['eventType'] = requestParameters.eventType
    }

    if (requestParameters.search !== undefined) {
      queryParameters['search'] = requestParameters.search
    }

    if (requestParameters.eventCreator !== undefined) {
      queryParameters['eventCreator'] = requestParameters.eventCreator
    }

    if (requestParameters.fromDate !== undefined) {
      queryParameters['fromDate'] = requestParameters.fromDate
    }

    if (requestParameters.toDate !== undefined) {
      queryParameters['toDate'] = requestParameters.toDate
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/events/leadershipTraining`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FetchLeadershipTrainingEventsResponseFromJSON(jsonValue)
    )
  }

  /**
   * Provides a list of internal events for the requester:    ## FILTERING:  - search: search text must be at least 3 characters in length. Including this query parameter will match your search text to an event\'s name, postal code or creator. - eventType: will return events within the specific type - eventCreator: will return events for the specific creator   ## PAGINATION:  - If pagination query parameters are included, the request will be paginated and ordered by the specified page, pageSize, and orderBy. - orderBy: valid order by properties include: name, startDate, startTime, CreatedBy, city, eventTypeKey. Supplying anything else will result in an error. - The requested pagination will be returned in the response, including the total count of all entries, which will allow the requester to calculate the total number of pages available with the current pageSize.      ## PERMISSIONS:  - The requester must have an active Event/viewDetail permission, else a 403 status code will be returned. - A Event/viewDetail[their team\'s] permission allows the requester to fetch event within their downline. - A Event/viewDetail[any] permission allows the requester to fetch an event that anyone owns in the system.
   * Fetch existing internal events for the requester denoting if the requester is registered for any given event.
   */
  async fetchLeadershipTraining(
    requestParameters?: FetchLeadershipTrainingRequest
  ): Promise<FetchLeadershipTrainingEventsResponse> {
    const response = await this.fetchLeadershipTrainingRaw(
      requestParameters || {}
    )
    return await response.value()
  }

  /**
   * Provide event details given an event identifier.
   * Fetch an existing event given an identifier.
   */
  async fetchPublicEventDetailsRaw(
    requestParameters: FetchPublicEventDetailsRequest
  ): Promise<runtime.ApiResponse<PublicEvent>> {
    if (
      requestParameters.publicEventId === null ||
      requestParameters.publicEventId === undefined
    ) {
      throw new runtime.RequiredError(
        'publicEventId',
        'Required parameter requestParameters.publicEventId was null or undefined when calling fetchPublicEventDetails.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request({
      path: `/events/search/{publicEventId}`.replace(
        `{${'publicEventId'}}`,
        encodeURIComponent(String(requestParameters.publicEventId))
      ),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PublicEventFromJSON(jsonValue)
    )
  }

  /**
   * Provide event details given an event identifier.
   * Fetch an existing event given an identifier.
   */
  async fetchPublicEventDetails(
    requestParameters: FetchPublicEventDetailsRequest
  ): Promise<PublicEvent> {
    const response = await this.fetchPublicEventDetailsRaw(requestParameters)
    return await response.value()
  }

  /**
   *  ## PERMISSIONS: - Requester must possess a User/view grant, otherwise a 403 will be returned. - User/view[their team\'s] grant allows the requester to view users only in the requester\'s downline. - User/view[any] grant allows the user to see all users that are able to manage the event types passed.  ## FILTERING: - search: search text must be at least 3 characters in length. Including this query parameter will match your search text to a user\'s firstName, lastName, username, email, and name of the role they actively have. - eventTypes: the types of events the caller is trying to find a possible owner for. This limits the actors returned to only those who have the Event/manage{type} grant where {type} is the types of events.  ## PAGINATION: - If pagination query parameters are not provided, pagination will not be included in the request. WARNING: this could cause a very large query and is not recommended unless the result set is known to be limited. - If pagination query parameters are included, the request will be paginated to the specified page and pageSize. - The requested pagination will be returned in the response, including the total count of all data, which will allow the requester to calculate the total amount of pages available with the current pageSize.
   * An endpoint to be able to search for possible event owners - active actors who are able to manage certain types of event. Takes into account the types of events that are being reassigned and verifies that the actor records can manage those events.
   */
  async searchPossibleEventOwnersRaw(
    requestParameters: SearchPossibleEventOwnersRequest
  ): Promise<runtime.ApiResponse<SearchPossibleEventOwnersResponse>> {
    const queryParameters: any = {}

    if (requestParameters.page !== undefined) {
      queryParameters['page'] = requestParameters.page
    }

    if (requestParameters.pageSize !== undefined) {
      queryParameters['pageSize'] = requestParameters.pageSize
    }

    if (requestParameters.orderBy) {
      queryParameters['orderBy'] = requestParameters.orderBy
    }

    if (requestParameters.search !== undefined) {
      queryParameters['search'] = requestParameters.search
    }

    if (requestParameters.eventTypes) {
      queryParameters['eventTypes'] = requestParameters.eventTypes
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/events/searchPossibleEventOwners`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      SearchPossibleEventOwnersResponseFromJSON(jsonValue)
    )
  }

  /**
   *  ## PERMISSIONS: - Requester must possess a User/view grant, otherwise a 403 will be returned. - User/view[their team\'s] grant allows the requester to view users only in the requester\'s downline. - User/view[any] grant allows the user to see all users that are able to manage the event types passed.  ## FILTERING: - search: search text must be at least 3 characters in length. Including this query parameter will match your search text to a user\'s firstName, lastName, username, email, and name of the role they actively have. - eventTypes: the types of events the caller is trying to find a possible owner for. This limits the actors returned to only those who have the Event/manage{type} grant where {type} is the types of events.  ## PAGINATION: - If pagination query parameters are not provided, pagination will not be included in the request. WARNING: this could cause a very large query and is not recommended unless the result set is known to be limited. - If pagination query parameters are included, the request will be paginated to the specified page and pageSize. - The requested pagination will be returned in the response, including the total count of all data, which will allow the requester to calculate the total amount of pages available with the current pageSize.
   * An endpoint to be able to search for possible event owners - active actors who are able to manage certain types of event. Takes into account the types of events that are being reassigned and verifies that the actor records can manage those events.
   */
  async searchPossibleEventOwners(
    requestParameters?: SearchPossibleEventOwnersRequest
  ): Promise<SearchPossibleEventOwnersResponse> {
    const response = await this.searchPossibleEventOwnersRaw(
      requestParameters || {}
    )
    return await response.value()
  }

  /**
   * Returns some events within a radius of either a postal code (preferred) or a city and state. If an event type is provided then only those events will be included. In addition, if an online or offline event is required results can be limited only to those events, by default both online and offline are displayed.
   * Find nearby events so that users can register to an event. The search can further be filtered by type of event or whether it is online or offline, when left blank all events are displayed.
   */
  async searchPublicEventsRaw(
    requestParameters: SearchPublicEventsRequest
  ): Promise<runtime.ApiResponse<SearchPublicEventsReply>> {
    const queryParameters: any = {}

    if (requestParameters.postalCode !== undefined) {
      queryParameters['postalCode'] = requestParameters.postalCode
    }

    if (requestParameters.usCitiesKey !== undefined) {
      queryParameters['usCitiesKey'] = requestParameters.usCitiesKey
    }

    if (requestParameters.milesRadius !== undefined) {
      queryParameters['milesRadius'] = requestParameters.milesRadius
    }

    if (requestParameters.fromDate !== undefined) {
      queryParameters['fromDate'] = (requestParameters.fromDate as any)
        .toISOString()
        .substr(0, 10)
    }

    if (requestParameters.showOnlineEvents !== undefined) {
      queryParameters['showOnlineEvents'] = requestParameters.showOnlineEvents
    }

    if (requestParameters.eventType !== undefined) {
      queryParameters['eventType'] = requestParameters.eventType
    }

    if (requestParameters.eventCategory !== undefined) {
      queryParameters['eventCategory'] = requestParameters.eventCategory
    }

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request({
      path: `/events/search`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      SearchPublicEventsReplyFromJSON(jsonValue)
    )
  }

  /**
   * Returns some events within a radius of either a postal code (preferred) or a city and state. If an event type is provided then only those events will be included. In addition, if an online or offline event is required results can be limited only to those events, by default both online and offline are displayed.
   * Find nearby events so that users can register to an event. The search can further be filtered by type of event or whether it is online or offline, when left blank all events are displayed.
   */
  async searchPublicEvents(
    requestParameters?: SearchPublicEventsRequest
  ): Promise<SearchPublicEventsReply> {
    const response = await this.searchPublicEventsRaw(requestParameters || {})
    return await response.value()
  }

  /**
   * Update an existing Event.
   */
  async updateEventRaw(
    requestParameters: UpdateEventRequest
  ): Promise<runtime.ApiResponse<void>> {
    if (
      requestParameters.body === null ||
      requestParameters.body === undefined
    ) {
      throw new runtime.RequiredError(
        'body',
        'Required parameter requestParameters.body was null or undefined when calling updateEvent.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/events`,
      method: 'PUT',
      headers: headerParameters,
      query: queryParameters,
      body: EventToJSON(requestParameters.body),
      $signal: requestParameters.$signal,
    })

    return new runtime.VoidApiResponse(response)
  }

  /**
   * Update an existing Event.
   */
  async updateEvent(requestParameters: UpdateEventRequest): Promise<void> {
    await this.updateEventRaw(requestParameters)
  }
}

/**
 * @export
 * @enum {string}
 */
export enum SearchPublicEventsEventTypeEnum {
  InformationMeeting = 'Information Meeting',
  OpenHouse = 'Open House',
  Practicum = 'Practicum',
  ParentPracticum = 'Parent Practicum',
  ClassicalConversationsOverview = 'Classical Conversations Overview',
  WindowsIntoProgram = 'Windows Into Program',
  ExcellenceInEducationEvent = 'Excellence in Education Event',
  ParentEquipping = 'Parent Equipping',
  ExperienceCurriculum = 'Experience Curriculum',
  CurriculumAtHome = 'Curriculum At Home',
  BookClub = 'Book Club',
  SalesOrientation = 'Sales Orientation',
  Retreats = 'Retreats',
  LcdOrientation = 'LCD Orientation',
  OtherDiscover = 'Other - Discover',
  OtherExperience = 'Other - Experience',
  OtherPrepare = 'Other - Prepare',
  OtherLeadershipTraining = 'Other - Leadership Training',
}
